<template>
	<div>
		<!-- Toolbar -->
		<Toolbar />
		<v-content  v-if="loaded">
			<v-container>
				<v-row justify="center">
					<v-card width="600"> 
						<v-card-title class="title font-weight-black">DATOS CONTRATO</v-card-title>
							<v-card-text>
								<v-container>
									<v-form v-model="formValidity">
										<v-row>
											<v-col cols="12" md="12">
												 <v-text-field
													color="accent"
													v-model="customerForEdit.name"
													label="Nombre fiscal"
													prepend-inner-icon="mdi-account-circle"
													:rules="textRules"
													dense
													filled />
												<v-text-field
													color="accent"
													v-model="customerForEdit.phone"
													label="Teléfono"
													prepend-inner-icon="mdi-cellphone-basic"
													:rules="textRules"
													dense
													filled /> 
												<v-text-field
													color="accent"
													v-model="customerForEdit.email"
													prepend-inner-icon="mdi-email"
													:rules="emailRules"
													label="E-mail"
													dense
													filled />
												<v-textarea
													color="accent"
													filled
													v-model="customerForEdit.address"
													prepend-inner-icon="mdi-message-reply-text"
													label="Dirección"
													:value="customerForEdit.address"
													rows="2"/> 
											</v-col>
										</v-row>
									</v-form>
								</v-container>
							</v-card-text>
							<v-card-actions>
							<v-spacer></v-spacer>
								<v-btn :loading="saving" class="white--text" color="accent" @click.stop="update">ACTUALIZAR PERFIL</v-btn>
							</v-card-actions>
					</v-card>
				</v-row>
			</v-container>
		</v-content>

		<v-container v-if='!loaded' fill-height>
			<v-layout flex align-center justify-center>
				<v-progress-circular indeterminate :size="100" :widht="45" color="secondary" />
			</v-layout>
		</v-container>
		<!-- <Notification /> -->
		<v-snackbar
			top
			right
			:timeout="alert.timeout"
			:color="alert.color"
			v-model="alert.show">
				{{ alert.message }}
		</v-snackbar>



	</div>
</template>

<script>
	import { db, storage } from '@/main';
	import { mapState, mapActions, mapGetters} from 'vuex';
	export default {

		name: 'UserDashboard',
		props: ['cutomr'],
		components: {
			Toolbar: () => import('@/components/customer/Toolbar.vue'),
		},
		created() {
			this.$store.commit('categoryModule/SET_SHOW_BTN_TOOLBAR', true, {root: true})
			this.loaded = false;
			if (this.cutomr){
				this.customerForEdit = this.cutomr;
				this.loaded = true;
			} else {
			 this.getCurrentUser()	
			}
		},
		data: () => ({
			customerForEdit: {},
			loaded: false,
			saving: false,
			createUser: false,
			formValidity: false,
			textRules: [v => !!v || "Este dato es requerido"],
			emailRules: [
				value => !!value || 'Email is required.',
				value => value.indexOf('@') !== 0 || 'Email shoud have a username',
				value => value.includes('@') || 'Email should include an @ symbol',
				value => value.indexOf('.') - value.indexOf('@') > 1 || 'Email should contain a valid domain.',
				value => value.indexOf('.') <= value.length - 3 || 'Email should contain a valid domain extension'
			],
		}),
		methods: {
			...mapActions('userModule', ['getUser']),
			update(){
				this.saving = true;
				db.collection('customers').doc(this.customerForEdit.id)
					.update( this.customerForEdit )
					.then( docRef => {
							this.$store.commit('SET_ALERT_MESSAGE', {
								show: true,
								color: 'success',
								message: 'Cliente actualizado satisfactoriamente',
								timeout: 1000
							});
							this.saving = false
						})
					.catch( e => {
						console.log('error', e )
						this.saving = false
					})
			},
			getCurrentUser(){
				this.getUser(this.$store.state.authModule.user.uid).then(res=>{
					this.customerForEdit = this.$store.state.userModule.user;
					//console.log('==== ' +  this.customerForEdit.name)
					this.loaded = true;
				});
			},
		},
		computed: {
			...mapState(['alert']),
			...mapGetters('userModule',['currentUser']),

		} // .computed
	}
</script>

<style>

</style>